import { Pagination } from "../../components/pagination";
import { BlogPost } from "../../templates/_BlogPostTemplate";
import { postsList } from "../../actions/blog/_GetPostsListAction";
import persianDate from "persian-date";
import { SizeUtils } from "../../utils/_SizeUtils";

const window_width = SizeUtils.windowWidth();
let current_page = +window.location.hash.replace("#P", "");
current_page = current_page > 0 ? current_page : 1;
const PAGE_SIZE = 6;

const $posts_list = $("#other_posts_container");

const pagination = new Pagination("#pagination", null, {
    itemsOnPage: PAGE_SIZE,
    onPageClick: (page_number) => {
        loadPosts(page_number).then((response) => {
            putPosts(response);
        });
    },
});

/**
 * @param {number} [page]
 * @param {number} [size]
 *
 * @return {Promise}
 */
async function loadPosts(page = null, size = null) {
    const page_to_load = page ?? current_page;
    const size_to_load = size ?? PAGE_SIZE;

    const response = await postsList(
        null,
        null,
        null,
        page_to_load,
        size_to_load
    );
    return response;
}

/**
 *
 *
 * @param {string} date
 * @return {string}
 */
function convertDate(date) {
    return new persianDate(new Date(date)).format("YYYY/MM/DD");
}

$(() => {
    // load slider posts
    loadPosts(1, 3).then((response) => {
        if ("data" in response) {
            const first_3 = response.data;
            const items = first_3
                .map((p, i) => {
                    const active = i === 0 ? "active" : "";
                    return `
                    <div class="carousel-item ${active}">
                        <img src="/${p.images.headers.desktop}" class="d-block w-100" alt="...">

                        <div class="carousel-caption">
                            <a href="/blog/post/${p.id}" class="carousel_title">${p.title}</a>
                            <a href="/blog/post/${p.id}" class="carousel_open_post">
                                <span>مطالعه‌ی مطلب</span>
                                <i class="icon pi-chevron-left"></i>
                            </a>
                        </div>
                    </div>
                `;
                })
                .join(" ");

            $("#postscarousel .carousel-inner").append(items);
        }
    });

    // First posts load
    loadPosts().then((response) => {
        putPosts(response);
    });
});

function putPosts(response) {
    if ("data" in response) {
        const posts = response.data;
        // rest of the posts
        if (posts.length > 0) {
            $posts_list.empty();
            for (let post of posts) {
                post.date = convertDate(post.created_at);
                let options = {
                    horizontal: false,
                    smallImage: false,
                    thumb: false,
                };

                if (window_width < 768) {
                    options.horizontal = true;
                    options.smallImage = true;
                }
                new BlogPost(post, options).addTo("other_posts_container");
            }
        } else {
            $("#other_posts").hide();
            pagination.destroy();
        }
    }

    if ("total" in response) {
        if (response.total / pagination.options.itemsOnPage > 1) {
            pagination.add();
            pagination.$elm.pagination("updateItems", response.total);
        } else {
            pagination.destroy();
        }
    }
}
